import { JsonRpcProvider as o, ethers as c } from "ethers";
import { ChainId as d, CHAIN_ID_TO_NETWORKISH as s, getRPC as w, RPCProvider as I, Networkish as a, NETWORKISH_TO_CHAIN_ID as l, initContractAddresses as C, initContractABIs as f } from "@deorderbook/contracts";
import { initTokens as h } from "../ethereum/token.mjs";
let k;
async function T() {
  k = await new c.BrowserProvider(window.ethereum).getSigner();
}
let e = d.ETH_MAINNET, i = s(e), t = "TtUuJPDXu8kBz-X364WffQiq0kKH8ZBH", m = new o(
  w(e, I.ALCHEMY, t),
  i
), A = !1;
function v(r, n = !1) {
  e = r.network in a ? l(r.network) : r.network, i = s(e), t = r.rpcKey, m = new o(
    w(e, I.ALCHEMY, t),
    r.network
  ), A = n, C(e), f(e), h(e), n && console.log(
    `CURRENT SDK CONFIG:
      
- chainId: ${e}
      
- networkish: ${i}
      
- alchemyAPIKey: ${t}`
  );
}
export {
  t as alchemyAPIKey,
  e as chainId,
  A as debug,
  T as initSigner,
  i as networkish,
  m as provider,
  v as setProvider,
  k as signer
};
//# sourceMappingURL=provider.mjs.map
